import React from "react";

import Icon from "components/Icon";

import { Wrapper } from "./styles";

const ArrowButton = ({ onClick, type, shade }) => {
  const alt = type === "next" ? "Next" : "Previous";
  return (
    <Wrapper type={type} onClick={onClick} shade={shade}>
      <Icon icon="arrow" title={alt} size="25px" />
    </Wrapper>
  );
};

export default ArrowButton;
